import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Strong, Text } from '@grandvisionhq/iris-ui';
import { isDefined } from '@grandvisionhq/utils';
import { PriceTagOrIncluded } from '../../PriceTagOrIncluded/PriceTagOrIncluded.js';

const ConfigurationSummaryRow = ({ label , labelVariant ='caption-head' , priceTextVariant ='caption-head' , priceSize , value , price , discountText , className , pricePrefix , step , 'data-t': dataT  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('configuration-summary-row', className),
        "data-t": dataT || 'configuration-summary-row'
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Strong, {
        variant: labelVariant
    }, label), /*#__PURE__*/ React.createElement(Text, {
        variant: "caption",
        className: "configuration-summary-row__value"
    }, value)), isDefined(price) && /*#__PURE__*/ React.createElement(PriceTagOrIncluded, swcHelpers.extends({}, price, {
        textVariant: priceTextVariant,
        discountText: discountText,
        pricePrefix: pricePrefix,
        size: priceSize,
        step: step
    })));
};

export { ConfigurationSummaryRow };
//# sourceMappingURL=ConfigurationSummaryRow.js.map
